import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  title: string;
  children?: ReactNode;
}

// Estado vacío cuidado para secciones sin contenido todavía.
export function EmptyState({ title, children }: EmptyStateProps) {
  return (
    <section className={styles.root}>
      <h2 className={styles.title}>{title}</h2>
      {children ? <div className={styles.body}>{children}</div> : null}
    </section>
  );
}
